import { isQuestionnaireEnabled } from '@/feature/questionnaire.feature';
import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { selectAssetStatus, selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { analyticsEvents, trackAnalyticsEvent } from '@/utils/analytics.utils';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetQuestionnaireListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);
    const orderType = selectOrderType(data);
    const assetStatus = selectAssetStatus(data);

    if (!isQuestionnaireEnabled({ assetType, orderType, assetStatus })) {
        return null;
    }

    return (
        <ListViewItem
            title={translate('questionnaire_modal_title')}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.QUESTIONNAIRE);
                trackAnalyticsEvent({
                    eventName: analyticsEvents.modalOpened,
                    custom: {
                        assetId,
                        id: 'questionnaire_modal',
                    },
                });
                onClose?.();
            }}
        />
    );
};

export const AssetQuestionnaireAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }

    return <AssetQuestionnaireListItem key="questionnaire-list-item" {...props} />;
};
